import axios from "axios";

export async function uploadFilesToS3Directly(
  url,
  subdirectoryPath,
  files,
  bucket,
  setProgress
) {
  const formData = new FormData();
  formData.append('subdirectoryPath', subdirectoryPath + '/');
  formData.append('bucket', bucket);

  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i].file);
  }

  await axios.post(url + '/upload_files_to_s3', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      const percentComplete = parseInt((progressEvent.loaded / progressEvent.total) * 100);
      setProgress(percentComplete);
    },
  });
}

export async function uploadPictureToS3Directly(properize_id, side, url, file) {
  const formData = new FormData();
  formData.append('subdirectoryPath', properize_id + "-");
  formData.append('filename', side + '.jpg')
  formData.append('bucket', 'properize-id-cards');
  formData.append('file', file);

  await axios.post(url + '/upload_file_to_s3', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
